import styled from 'styled-components';
import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';

export const SectionTitle = styled.h2`
  display: block;
  width: 100%;
  margin: 0 auto 45px auto;
  font-family: cormorant-garamond, serif;
  font-style: normal;
  font-size: 36px;
  font-weight: 500;
  color: #000000;
  line-height: 40px;
  text-align: center;
  ${whiteTheme.media.mobileM} {
    font-size: 30px;
    margin-bottom: 20px;
  }
`;
